<template>
  <div class="qr-code-citizen">
    <div class="qr-code-citizen-card">
      <div class="qr-code-citizen-card-title">基本信息</div>
      <div class="qr-code-citizen-card-box">
        <div class="citizen-card-box-row">
          <div class="box-row-label">所属区域名称</div>
          <div class="box-row-value">{{ pagetData.townName }}</div>
        </div>
        <div class="citizen-card-box-row">
          <div class="box-row-label">道路（小区）</div>
          <div class="box-row-value">{{ pagetData.roadName }}</div>
        </div>
        <div class="citizen-card-box-row">
          <div class="box-row-label">管井编号</div>
          <div class="box-row-value">{{ pagetData.gdid }}</div>
        </div>
        <div class="citizen-card-box-row">
          <div class="box-row-label">井底标高</div>
          <div class="box-row-value">
            {{ pagetData.bottomholeElevation || '-' }}
          </div>
        </div>
        <div class="citizen-card-box-row">
          <div class="box-row-label">管井类型</div>
          <div class="box-row-value">
            {{ pagetData.source == '1' ? '雨水' : '污水' }}
          </div>
        </div>
        <div class="citizen-card-box-row">
          <div class="box-row-label">易堵易冒</div>
          <div class="box-row-value">
            {{ pagetData.blockBurst == '0' ? '否' : '是' }}
          </div>
        </div>
        <div class="citizen-card-box-row">
          <div class="box-row-label">修建年代</div>
          <div class="box-row-value">{{ pagetData.inwellEra }}</div>
        </div>
        <div class="citizen-card-box-row">
          <div class="box-row-label">井脖深</div>
          <div class="box-row-value">{{ pagetData.neckDepth || '-' }}</div>
        </div>
        <div class="citizen-card-box-row">
          <div class="box-row-label">井底埋深</div>
          <div class="box-row-value">{{ pagetData.burialDepth || '-' }}</div>
        </div>
        <div class="citizen-card-box-row">
          <div class="box-row-label">井盖材质</div>
          <div class="box-row-value">{{ pagetData.manholeCoverMaterial }}</div>
        </div>
        <div class="citizen-card-box-row">
          <div class="box-row-label">井盖形状</div>
          <div class="box-row-value">{{ pagetData.shape }}</div>
        </div>
        <div class="citizen-card-box-row">
          <div class="box-row-label">井盖直径</div>
          <div class="box-row-value">{{ pagetData.wellZj || '-' }}</div>
        </div>
        <div class="citizen-card-box-row">
          <div class="box-row-label">探测单位</div>
          <div class="box-row-value">{{ pagetData.tcdw }}</div>
        </div>
        <div class="citizen-card-box-row">
          <div class="box-row-label">探测日期</div>
          <div class="box-row-value">{{ pagetData.tcrq }}</div>
        </div>
        <div class="citizen-card-box-row">
          <div class="box-row-label">养护状态</div>
          <div class="box-row-value">{{ pagetData.yhzt }}</div>
        </div>
      </div>
    </div>
    <!-- <div class="qr-code-citizen-card">
      <div class="qr-code-citizen-card-title">养护信息</div>
      <div class="qr-code-citizen-card-box">
        <div class="citizen-card-box-row">
          <div class="box-row-label">养护单位</div>
          <div class="box-row-value">苏州群业管网</div>
        </div>
        <div class="citizen-card-box-row">
          <div class="box-row-label">养护日期</div>
          <div class="box-row-value">2024/01/38</div>
        </div>
        <div class="citizen-card-box-row">
          <div class="box-row-label">检测单位</div>
          <div class="box-row-value"></div>
        </div>
        <div class="citizen-card-box-row">
          <div class="box-row-label">检测日期</div>
          <div class="box-row-value"></div>
        </div>
      </div>
    </div> -->
    <div class="qr-code-citizen-footer">
      <div class="qr-code-citizen-footer-item">
        <div class="citizen-footer-item-title">报修电话</div>
        <div class="citizen-footer-item-call">0512-63177111</div>
      </div>
      <div class="qr-code-citizen-footer-item">
        <img src="@/assets/qrCode/icon-call.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import qrCodeCitizen from '@/api/qrCodeCitizen';
export default {
  data() {
    return {
      pagetData: {},
    };
  },

  created() {
    const currentUrl = window.location.href;
    const id = currentUrl.match(/id=([^&]*)/)[1];
    this.queryWellLidInfo(id);
  },

  methods: {
    async queryWellLidInfo(id) {
      const res = await qrCodeCitizen.queryWellLidInfo({ id });
      // console.log(res.data.data);
      this.pagetData = res.data.data;
    },
  },
};
</script>

<style lang="less" scoped>
.qr-code-citizen {
  min-height: 100vh;
  background-color: #f2f4f7;
  overflow-x: hidden;
  .qr-code-citizen-card {
    .qr-code-citizen-card-title {
      padding: 8px 10px;
      font-size: 12px;
      color: #999999;
    }

    .qr-code-citizen-card-box {
      background-color: #ffffff;
      padding-left: 10px;
      display: flex;
      flex-direction: column;
      .citizen-card-box-row {
        padding: 10px 10px 10px 0;
        border-bottom: 1px solid #f0f0f0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .box-row-label {
          font-size: 13px;
          color: #666666;
        }
        .box-row-value {
          font-size: 13px;
          color: #333333;
        }
      }
    }
  }

  .qr-code-citizen-footer {
    margin: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 12px;
    border-radius: 10px;
    box-sizing: border-box;
    background-color: #ffffff;
    .qr-code-citizen-footer-item {
      .citizen-footer-item-title {
        font-size: 13px;
        color: #666666;
        margin-top: 8px;
      }

      .citizen-footer-item-call {
        font-size: 17px;
        font-weight: bold;
        color: #347fff;
        margin: 10px 0 11px 0;
      }

      & > img {
        width: 92px;
        height: 65px;
      }
    }
  }
}
</style>

<style>
body {
  overflow-x: hidden;
}
</style>
